// Product image imports - all images are in src/assets/products/
import samboardOrangeMain from "@/assets/products/samboard-orange-main.png";
import educationKit1500 from "@/assets/products/education-kit-1500.png";
import educationKitBlack from "@/assets/products/education-kit-black.png";
import accessToWorkStacked from "@/assets/products/access-to-work-stacked.png";
import librarySquaresSet3Black from "@/assets/products/library-squares-set-3-black.png";
import textureRockGreen from "@/assets/products/texture-rock-green.png";
import rockLibrarySquareGreen from "@/assets/products/rock-library-square-green.jpg";
import agriYellowSquares from "@/assets/products/agri-yellow-squares.png";
import sensoryPadRed from "@/assets/products/sensory-pad-red.png";
import agriSensoryPads5Colored from "@/assets/products/agri-sensory-pads-5-colored.png";
import agriSensoryPadBlue from "@/assets/products/agri-sensory-pad-blue.png";
import librarySquareWhiteSet from "@/assets/products/library-square-white-set.jpg";
import librarySquareBlackSet from "@/assets/products/library-square-black-set.jpg";
import unicornLibrarySquare from "@/assets/products/unicorn-library-square.jpg";
import unicornLibrarySquareWhite from "@/assets/products/unicorn-library-square-white.png";
import unicornLibrarySquareWhiteSet from "@/assets/products/set-3-unicorn-library-square-white.png";
import unicornLibrarySquareBlackSet from "@/assets/products/set-3-unicorn-library-square-black.png";
import pointsLibrarySquare from "@/assets/products/points-library-square.jpg";
import rockLibrarySquare from "@/assets/products/rock-library-square.jpg";
import textureLibrarySquare from "@/assets/products/texture-library-square.jpg";
import set3RockLibrarySquareBlack from "@/assets/products/set-3-rock-library-square-black.jpg";
import set3RockLibrarySquareWhite from "@/assets/products/set-3-rock-library-square-white.jpg";
import set3PointsLibrarySquareBlack from "@/assets/products/set-3-points-library-square-black.jpg";
import samboardsLanyard from "@/assets/products/samboards-lanyard.jpg";
import satpinBoard from "@/assets/products/satpin-board.png";

// Product image mapping by slug
export const productImageMap: Record<string, string> = {
  "/samboards": samboardOrangeMain,
  "/product/education-kit-school-1500": educationKit1500,
  "/product/education-kit-school-1000": educationKitBlack,
  "/product/education-kit-school-500": educationKitBlack,
  "/product/education-kit-school-250": educationKitBlack,
  "/product/education-kit-school-125": educationKitBlack,
  "/access-to-work-kits": accessToWorkStacked,
  "/product/set-3-points-library-square-white": librarySquareWhiteSet,
  "/product/set-3-points-library-square-black": set3PointsLibrarySquareBlack,
  "/product/set-3-rock-library-square-white": set3RockLibrarySquareWhite,
  "/product/set-3-rock-library-square-black": set3RockLibrarySquareBlack,
  "/product/set-3-unicorn-library-square-white": unicornLibrarySquareWhiteSet,
  "/product/set-3-unicorn-library-square-black": unicornLibrarySquareBlackSet,
  "/product/unicorn-library-square": unicornLibrarySquare,
  "/product/points-library-square": pointsLibrarySquare,
  "/product/rock-library-square": rockLibrarySquare,
  "/product/texture-library-square": textureLibrarySquare,
  "/product/rock-library-square-green": rockLibrarySquareGreen,
  "/product/agri-points-library-square-yellow": agriYellowSquares,
  "/product/agri-texture-library-square": agriYellowSquares,
  "/product/set-2-agri-library-squares-yellow": agriYellowSquares,
  "/product/set-5-agri-sensory-pads": agriSensoryPads5Colored,
  "/product/samboards-sensory-pads-large": sensoryPadRed,
  "/product/agri-biodegradable-plastic-sensory-pads": agriSensoryPadBlue,
  "/product/samboards-lanyard": samboardsLanyard,
  "/satpin": satpinBoard,
};

// Products still needing images:
// - Mini Samboards
// - Library Squares (main page)
// - Sensory Pads (main page) 
// - Fidget Squares
// - Equestrian Range
// - Satpin Board
// - Samboards Lanyard
